import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, Input, SimpleChanges } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { DishServices } from '../../../dish/services';
import * as moment from 'moment';
import { StockCostEvolutionPage } from '../../../analytics/reports/stock-cost-evolution/stock-cost-evolution';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the ArticleViewAnalyticsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-article-view-analytics',
    templateUrl: 'article-view-analytics.html',
})
export class ArticleViewAnalyticsPage {
    @Input() article: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        private http: HttpClient,
        public globals: Globals,
        public dishServices: DishServices) {

    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.article && this.article.UID) {
            if (this.article.type === 'dish') {
                if (this.globals.checkLimitsByLicense('dishes', 'analitycs')) {
                    // Optimización: ejecutar las 3 peticiones en paralelo en lugar de secuencialmente
                    Promise.all([
                        this.getTotalDishSales(),
                        this.getTotalDishSalesLasts30days(),
                        this.getDishCostLastMonths()
                    ]).catch(error => {
                        console.error('Error cargando analytics de dish:', error);
                    });
                }
            } else if (this.article.type === 'product') {
                if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
                    // Optimización: ejecutar las 3 peticiones en paralelo en lugar de secuencialmente
                    Promise.all([
                        this.getTotalProductSales(),
                        this.getProductCostLastMonths(),
                        this.getTotalProductSalesLasts30Days()
                    ]).catch(error => {
                        console.error('Error cargando analytics de product:', error);
                    });
                }
            }
        }
    }


    total_dish_sales: number = 0;
    total_dish_sales_billing: number = 0;
    getTotalDishSales() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.article.name_es);
        this.http.post(this.globals.analytics_path + 'bidish/get_total_dish_sales', params, {})
            .subscribe(res => {
                this.total_dish_sales = res[0].total_dish_sales;
                this.total_dish_sales_billing = this.total_dish_sales * this.article.price;
            });
    }

    total_dish_sales_lasts30_days: number = 0;
    total_dish_sales_billing_lasts30_days: number = 0;
    getTotalDishSalesLasts30days() {
        let last_date = moment().subtract(30, 'days').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.article.name_es)
            .set('last_date', last_date);
        this.http.post(this.globals.analytics_path + 'bidish/get_total_dish_sales_lasts_30days', params, {})
            .subscribe(res => {
                this.total_dish_sales_lasts30_days = res[0].total_dish_sales_lasts_30days;
                this.total_dish_sales_billing_lasts30_days = this.total_dish_sales_lasts30_days * this.article.price;
            });
    }

    public _dish_cost_last_months: any = 0;
    public dish_cost_last_months: any = 0;
    public dish_cost_state = '';
    dish_cost_percent: any; //mostraremos el procentaje en la view
    async getDishCostLastMonths() {
        var dish = await this.dishServices.getDish(this.article.UID);
        let last_date = moment().subtract(12, 'months').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.article.name_es)
            .set('last_date', last_date);
        this.http.post(this.globals.analytics_path + 'bidish/get_dish_cost_last_months', params, {})
            .subscribe(res => {
                this._dish_cost_last_months = res[0].dish_cost_last_months;
                //Calculamos coste de los ultimos mesesx
                let _dish_foodcost = dish.foodcost_static / dish.foodcost_parts; // calculamos foodcost del dish

                this.dish_cost_percent = 100 - this.globals.regla3(this._dish_cost_last_months, _dish_foodcost); //REstamos sobre 100 por tener el porcentaje

                if (this._dish_cost_last_months > _dish_foodcost) {
                    this.dish_cost_state = 'positive';
                } else {
                    this.dish_cost_state = 'negative';
                    this.dish_cost_percent = Math.abs(this.dish_cost_percent);
                }
            });
    }

    //PRODUCT
    get_total_product_sales: any = 0;
    getTotalProductSales() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.article.name);
        this.http.post(this.globals.analytics_path + 'biproduct/get_total_product_sales', params, {})
            .subscribe(async res => {
                this.get_total_product_sales = res['total_product_sales'];
            });
    }

    get_total_product_sales_lasts_30days: any = 0;
    async getTotalProductSalesLasts30Days() {
        let today = moment();
        let date = await today.subtract(30, 'days').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.article.name)
            .set('last_date', date);
        this.http.post(this.globals.analytics_path + 'biproduct/get_total_product_sales_lasts_30days', params, {})
            .subscribe(async res => {
                this.get_total_product_sales_lasts_30days = res['total_product_sales_lasts_30days'];
            });
    }

    public _product_cost_last_months: any = 0;
    public product_cost_state = '';
    public product_cost_percent: any; //mostraremos el procentaje en la view
    public _product_foodcost = 0;
    async getProductCostLastMonths() {
        let today = moment();
        let date = await today.subtract(90, 'days').format("YYYY-MM-DD");

        await this.globals.delay(1500);

        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('product_name', this.article.name)
            .set('last_date', date);
        this.http.post(this.globals.analytics_path + 'biproduct/get_product_cost_last_months', params, {})
            .subscribe(async res => {
                this._product_cost_last_months = res['product_cost_last_months'];

                if (this.article.sub_recipe) {
                    this._product_foodcost = this.article.price_static / this.article.foodcost_parts; // calculamos foodcost del dish
                } else {
                    this._product_foodcost = this.article.price_static / 1; // calculamos foodcost del dish
                }

                this.product_cost_percent = 100 - this.globals.regla3(this._product_cost_last_months, this._product_foodcost);

                if (this._product_cost_last_months > this._product_foodcost) {
                    this.product_cost_state = 'positive';
                } else {
                    this.product_cost_state = 'negative';
                    this.product_cost_percent = Math.abs(this.product_cost_percent);
                }
            });
    }

    openStockCostEvolutionPage(article) {
        if (this.globals.checkLimitsByLicense('stock', 'analitycs')) {
            this.navCtrl.push(StockCostEvolutionPage, {
                element: article
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }
}



// WEBPACK FOOTER //
// ./src/pages/articles/articles-view/article-view-analytics/article-view-analytics.ts